<template>
    <div class="settings__prints">
        <v-radio-group v-model="step" inline class="1234">
            <v-radio :label="v.label" :value="v.value" v-for="(v, i) in option" :key="i" color="red"></v-radio>
        </v-radio-group>
        <div class="settings__prints-box-button">
            <ButtonCommon text="Print Test Ticket" :isNoHover="true" :disable="isPrinting" @action-button="onTicketTest" />
            <!-- <ButtonCommon type="primary" text="Refresh" :isNoHover="true" @action-button="onRefresh" /> -->
        </div>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'
import printMixins from "@/mixins/print/print-mixins";
import ButtonCommon from '@/components/common/button'

export default {
    mixins: [languageMixins, printMixins],
    components: { ButtonCommon },

    mounted() {
        document.addEventListener('message', this.handleMessage)
    },
    beforeDestroy() {
        document.removeEventListener('message', this.handleMessage)
    },

    data() {
        return {
            step: 1,
            isPrinting: false,
            option: [
                // {
                //     label: 'Select Printer 1St One',
                //     value: 1,
                // },
                {
                    label: 'Use Internal Printer',
                    value: 1,
                },
            ]
        }
    },
    methods: {
        handleMessage(event) {
            // example to handle print status (success, error)
            const resp = JSON.parse(event.data)
            if (resp.type === 'print-success') {
                this.isPrinting = false
                // alert('print success')
            }
            else if (resp.type === 'print-error') {
                this.isPrinting = false
                alert(resp.errorMessage)
            }
        },

        async onTicketTest() {
            // donothing if app is printing
            if (this.isPrinting) return

            let fakeTickets = [{ logo: 'both', align: 'c' },
            { emptyLines: 2 },
            { text: 'Test Printer', bold: true, textSize: 35, align: 'c' },
            { emptyLines: 1 }]

            await this.prepareLogoAsSingleObject(JSON.stringify(fakeTickets));

            parent.postMessage({ command: 'print-test', data: fakeTickets, defaultSunmiFont: this.$store.state.configAccount?.sunmiPrinterFont }, '*')
            this.isPrinting = true
        },
        // onRefresh() {
        //     console.log('Refresh')
        // },
    },
}
</script>
<style lang="scss">
@import '~ThemePath/scss/settings/_print.scss';
</style>
